import { render, staticRenderFns } from "./abstract.vue.html?vue&type=template&id=1ec5b3e3"
import script from "./abstract.controller?vue&type=script&lang=js&external"
export * from "./abstract.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports